import React, { useId } from 'react';
import { CustomeSlide } from '../../../../core/CustomeSlide';
import { useRegisterDialogPage } from '../../../../core/DialogPresenter/useRegisterDialogPage';
import Send from '../../../../generic/Send';

type ITestamentSendProps = unknown;

export const TestamentSend: React.FC<ITestamentSendProps> = props => {
  const id = useId();

  const pageNumber = useRegisterDialogPage(id, {
    title: 'Send',
  });

  return pageNumber === null ? null : (
    <CustomeSlide key={id} pageNumber={pageNumber} appear={false}>
      <Send />
    </CustomeSlide>
  );
};
